import React from 'react';
import { Application } from '../../../models';
import { LeaderboardIcon } from '../../icons';
import StatisticalForm from './StatisticalForm';

interface NinethStepProps {
  application?: Application;
  isReadOnly?: boolean;
}

export default function NinethStep({
  application = null,
  isReadOnly = false,
}: NinethStepProps) {
  return (
    <div className="p-6 lg:py-20 lg:px-32 flex flex-col">
      <div className="w-20 h-20 rounded-full bg-[#F5FFBB]/60 border border-[#F5FFBB] flex">
        <LeaderboardIcon className="h-12 w-12 m-auto text-light-green" />
      </div>
      <div className="mt-8">
        <h2 className="font-bold text-5xl text-neutral-600">
          Statistical Information
        </h2>
      </div>
      <div className="mt-8 w-full">
        <StatisticalForm
          application={application}
          isReadOnly={isReadOnly}
          statistical={{
            hear: application?.hear ?? [],
            other: application?.other,
          }}
        />
      </div>
    </div>
  );
}
